import {Injectable} from '@angular/core';
import {KluhManagerValidator} from '../../../../validators/kluh-manager-validator';
import {BaseMonitoringDao} from '../../../../base-monitoring-dao';
import {MemoryUsage} from '../../../../models-monitoring';
import {R2CloudHttpMonitoringService} from '../../../../r2-cloud-http-monitoring.service';

@Injectable({
    providedIn: 'root'
})
export class MemoryUsageDaoService extends BaseMonitoringDao<MemoryUsage> {
    constructor(http: R2CloudHttpMonitoringService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, '/memory-usage');
    }
}
